// extracted by mini-css-extract-plugin
module.exports = {"leadBlock":"InfoLeadBlock_leadBlock_2l7vz"};